<template>
  <v-app-bar app light flat color="primaryLight">
    <div class="d-flex align-center" style="margin: 0 auto;">
      <v-img contain :src="require('@/assets/white-logo.png')" transition="scale-transition" width="40"/>
      <h2 class="white--text pl-2">Dr. Asmah Health Hub</h2>
    </div>
  </v-app-bar>
</template>

<script>
  export default {
    name: 'Navbar'
  }
</script>

<style>

</style>